/* eslint-disable class-methods-use-this */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-template */

import debounce from '../utils/debounce.js';

const selectors = {
  sortForm: '[data-sort-form]',
  collectionGrid: '[data-collection-grid]',
};

class CollectionSort extends HTMLElement {
  constructor() {
    super();

    this.sortForm = this.querySelector(selectors.sortForm);
    this.collectionGrid = this.querySelector(selectors.collectionGrid);

    this.debouncedOnSubmit = debounce(event => {
      this.onSubmitHandler(event);
    }, 500);

    this.registerEventListeners();
  }

  registerEventListeners() {
    this.sortForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  getSectionId() {
    return this.collectionGrid.dataset.id;
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.updateURLHash(this.createSearchParams(this.sortForm));

    fetch(
      `${window.location.pathname}${window.location.search}&?${this.getSectionId}`
    )
      .then(response => response.text())
      .then(responseText => {
        const html = responseText;
        document.querySelector('[data-main-collection]').innerHTML =
          new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-main-collection]').innerHTML;
      });
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  updateURLHash(searchParams) {
    const [key, value] = searchParams.split('=');

    const params = new URLSearchParams(window.location.search);

    if (params.has('sort_by') || params.has('page')) {
      params.set(key, value);
      params.set('page', 1);
      history.replaceState(
        null,
        null,
        `${window.location.pathname}?${params.toString()}`
      );
    } else {
      history.pushState(
        null,
        null,
        `${window.location.pathname}${window.location.search}${
          searchParams && '?'.concat(searchParams)
        }`
      );
    }
  }
}

customElements.define('collection-sort', CollectionSort);
